import { render, staticRenderFns } from "./CalendarPatient.vue?vue&type=template&id=35d79e4f&"
import script from "./CalendarPatient.vue?vue&type=script&lang=ts&"
export * from "./CalendarPatient.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarPatient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports